<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Şube</label>
            <v-validator :errors="errors" parameter="ActiveBranchId" :watch="branch">
                <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Şube"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Hesap Kodu</label>
            <v-validator :errors="errors" parameter="NetsisPaymentAccountCode" :watch="hesap">
                <v-select-list :options="hesapList" :disabled="(hesapList || []).length == 0 || !branch" v-model="hesap" placeholder="Hesap Kodu"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">KYKM Tür Grubu</label>
            <v-validator :errors="errors" parameter="SalaryEffectTypeGroupId" :watch="group">
                <v-select-list v-model="group" :options="groups" label="Name" placeholder="KYKM Tür Grubu"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">KYKM Türü</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" v-model="value.Name" class="form-control" placeholder="KYKM Türü"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Öncelik</label>
            <v-validator :errors="errors" parameter="Priority" :watch="value.Priority"></v-validator>
            <input type="number" v-model="value.Priority" class="form-control" placeholder="Öncelik"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Kat Sayı</label>
            <v-validator :errors="errors" parameter="Multiple" :watch="value.Multiple">
                <b-form-spinbutton min="0" step="0.25" v-model="value.Multiple"></b-form-spinbutton>
            </v-validator>
        </div> 
        <!-- <div class="col-12 mb-1">
            <label class="form-label">Ödeme Tipi</label>
            <v-validator :errors="errors" parameter="Periodic" :watch="value.Periodic">
                <select class="form-control" v-model="value.Periodic">
                    <option :value="true">Periyodik</option>
                    <option :value="false">Rassal</option>
                </select>
            </v-validator>
        </div> -->
        <!-- <div class="col-12 mb-1" v-if="value.Periodic">
            <label class="form-label">Periyotlar</label>
            <ul class="list-group">
                <li class="list-group-item p-75" v-for="(p,index) in value.Periods" :key="'s'+index">
                    <div class="row align-items-end">                
                        <div class="col-12 mb-50 text-right">
                            <button class="btn btn-sm btn-outline-danger" v-on:click="$delete(value.Periods,index)">
                                Periyodu Sil
                            </button>
                        </div>
                        <div class="col-lg-3 mb-1 mb-md-0">
                            <label class="form-label">İlk Ödeme Tarihi</label>
                            <v-date-picker v-model="p.FirstPaymentDate" placeholder="İlk Ödeme Tarihi"></v-date-picker>
                        </div>
                        <div class="col-lg-3 mb-1 mb-md-0">
                            <label class="form-label">Periyot</label>
                            <b-form-spinbutton min="0" v-model="p.Period"></b-form-spinbutton>
                        </div>
                        <div class="col-lg-3 mb-1 mb-md-0">
                            <label class="form-label">Periyot Sıklığı</label>
                            <select class="form-control" v-model="p.Monthly">
                                <option :value="true">Aylık</option>
                                <option :value="false">Günlük</option>
                            </select>
                        </div>
                        <div class="col-lg-3 mb-1 mb-md-0">
                            <label class="form-label">Ödenecek Tutar</label>
                            <input class="form-control" type="number" v-model="p.Amount" placeholder="Ödenecek Tutar"/>
                        </div>
                    </div>
                </li>
                <li class="list-group-item p-50">
                    <button class="btn btn-success btn-sm btn-block" v-on:click="addPeriod">Periyot Ekle</button>
                </li>
            </ul>
        </div> -->
        <div class="col-12 mb-1">
            <label class="form-label">Çalışma Gün Türü</label>
            <v-validator :errors="errors" parameter="EmployeeWorkingTypeId" :watch="type">
                <v-select-list v-model="type" :options="types" label="Name"  placeholder="Çalışma Gün Türü"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Etki Yönü</label>
            <select class="form-control" v-model="value.Positive">
                <option :value="null">Nötr</option>
                <option :value="true">Artı</option>
                <option :value="false">Eksi</option>
            </select>
        </div>
        <div class="col-12">
            <label class="form-label">Sistem Kodu</label>
            <v-validator :errors="errors" parameter="SystemCode" :watch="value.SystemCode">
                <input type="text" v-model="value.SystemCode" class="form-control" placeholder="Sistem Kodu"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
import { BFormSpinbutton } from 'bootstrap-vue'
import HumanResourcesParameterApi from '@/api/human-resources-parameters' 
import EmployeeOperationsApi from '@/api/employee-operations'
import CompanyApi from '@/api/company'
import HRNetsisApi from '@/api/hr-netsis'

export default {
    components:{
        BFormSpinbutton
    },
    props:{
        value:Object,
        errors:Object,
        editing:Boolean
    },
    data() {
        return {
            groups:[],
            types:[],
            branches:[],
            hesapList:[]
        }
    },
    watch:{
        'value.ActiveBranchId'(oldV,newV){
            if(oldV != newV){
                this.getHesapList()
            }
        },
        "value.Positive"(newV,oldV){
            if(newV == null){
                if(this.value.Multiple > 0){
                    this.value.Multiple = 0
                }
            }
        },
    },
    mounted(){
        this.getSalaryTypeGroups()
        this.getTypes()
        this.getBranches().then(()=>{
            this.getHesapList()
        })
    },
    methods:{
        getSalaryTypeGroups(){
            HumanResourcesParameterApi.SalaryEffect.TypeGroup.List().then(res=>{
                this.groups = res.data.Data
            })
        },
        getTypes(){
            EmployeeOperationsApi.Score.WorkingType().then(res=>{
                this.types = res.data.Data
            })
        },
        getBranches(){
            return new Promise((resolve)=>{
                CompanyApi.Branch.ListByCode("S").then(res=>{
                    this.branches = res.data.Data
                    resolve()
                })
            })
        },
        getHesapList(){
            if(this.branch){
                HRNetsisApi.HesapList(this.branch?.Name).then(res=>{
                    this.hesapList = res.data.Data
                })
            }
        },
        // addPeriod(){
        //     this.value.Periods.push({
        //         FirstPaymentDate:null,
        //         Peroid:1,
        //         Monthly:false,
        //         Amount:null
        //     })
        // }
    },
    computed:{
        group:{
            get:function(){
                return this.groups.find(b=>b.Id==this.value.SalaryEffectTypeGroupId)
            },
            set:function(value){
                this.value.SalaryEffectTypeGroupId = value?.Id || null
            }
        },
        type:{
            get:function(){
                return this.types.find(b=>b.Id==this.value.EmployeeWorkingTypeId)
            },
            set:function(value){
                this.value.EmployeeWorkingTypeId = value?.Id || null
            }
        },
        branch:{
            get:function(){
                return this.branches.find(b=>b.Id==this.value.ActiveBranchId)
            },
            set:function(value){
                this.value.ActiveBranchId = value?.Id || null
            }
        },
        hesap:{
            get:function(){
                return this.hesapList.find(i=>i==this.value.NetsisPaymentAccountCode)
            },
            set:function(value){
                this.value.NetsisPaymentAccountCode = value || null
            }
        },
    }
}
</script>

<style>

</style>